module.exports = __webpack_public_path__ + "img/des_cooler_2.dae9cca9.jpg";